import React from "react";
import axios from "axios";
import "../pages/style/media.css";
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import Menu from "../home/Menu";
import { Grid, Row, Col } from "react-flexbox-grid";
import MapAddresse from "../home/mapAdresse";
import NewsLetter from "../home/newsLetter";
import Footer from "../home/footer";

import bgmedia from "../assets/media/bgmedia.png";

import article1 from "../assets/media/image_articles/A1.png";
import article2 from "../assets/media/image_articles/A2.png";
import article3 from "../assets/media/image_articles/A3.png";
import article4 from "../assets/media/image_articles/A4.png";
import article5 from "../assets/media/image_articles/A5.png";
import article6 from "../assets/media/image_articles/A6.png";
import article7 from "../assets/media/image_articles/A7.png";
import article8 from "../assets/media/image_articles/A8.png";
import article9 from "../assets/media/image_articles/A9.png";
import { MuiThemeProvider } from "material-ui/styles";
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   dataLayer: {
//     userProject: "Chifco_website",
//     page: "Media",
//   },
//   dataLayerName: "PageDataLayer",
// };

const contentStyle = {
  position: "relative",
  background: "linear-gradient(to right, #0c0abe , #07054c)",
  border: "none",
  width: "100%",
  textAlign: "center",
  padding: "0px !important",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "80px",
  paddingBottom: "100%",
};

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const Post = (props) => (
  <Col xs={12} sm={6} md={6} lg={4} className="MediaCol">
    <a href={props.post.url} rel="noopener noreferrer" target="_blank">
      <div className="imgContent">
        <img
          alt=""
          src={
            `${process.env.REACT_APP_SERVER}` +
            "/images/" +
            props.post.postImage
          }
        />
      </div>
      <div className="titleContent">
        <p className="MediaNews">{props.post.title}</p>
      </div>
    </a>
    <div className="paragContent">
      {/* <p> */}
        {" "}
        <p
          className="MediaNewsParag"
          dangerouslySetInnerHTML={{ __html: props.post.description }}
        />
        <a href={props.post.url} rel="noopener noreferrer" target="_blank">
          <span style={{ color: "#006bff" }}>Lire la suite</span>
        </a>
      {/* </p> */}
    </div>
    <p className="MediaNewsDate">
      {(props.date.getDay().toString().length > 1
        ? props.date.getDay()
        : "0" + props.date.getDay()) +
        " " +
        monthNames[props.date.getMonth()] +
        " " +
        props.date.getFullYear()}
    </p>
  </Col>
);

class Media extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Posts: [],
    };
  }

  componentDidMount() {
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/post/")
      .then((response) => {
        this.setState({ Posts: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  PostList() {
    return this.state.Posts.map((currentPost) => {
      var post_date = new Date(currentPost.date);
      return <Post post={currentPost} key={currentPost._id} date={post_date} />;
    });
  }

  render() {
    //TagManager.dataLayer(tagManagerArgs)
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Media</title>
          <link
            rel="canonical"
            href={
             // "https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT + 
              "/medias"
            }
          />
        </Helmet>
        <div className="banniereSlidMedia">
          {/*Menu horizontal Web*/}
          <div className="menu-horizontal">
            <Menu />
          </div>
          {/*Menu Responsive Popup*/}
          <div className="menuMobile">
            <Popup
              modal
              overlayStyle={{
                background: "linear-gradient(to right, #0c0abe , #07054c)",
                width: "100%",
              }}
              contentStyle={contentStyle}
              closeOnDocumentClick={false}
              trigger={(open) => <BurgerIcon open={open} />}
            >
              <SideList />
            </Popup>
          </div>

          <div className="flex-container-Media">
            <div className="UnderConstDiv">
              <h1 className="UnderStyle">
                Quoi de <b className="ConstructionStyle">neuf</b>
                <b style={{ color: "white", textTransform: "uppercase" }}> ?</b>
              </h1>
            </div>

            <div className="imgMediabg">
              <img className="imgObjectMedia" src={bgmedia} alt="" />
            </div>
          </div>
        </div>
        <div>
          <h1 className="mediaTitle">Ils parlent de nous</h1>

          <Grid className="MediaGrid">
            <Row className="MediaRow">{this.PostList()}</Row>
          </Grid>
        </div>
        <MapAddresse />
        <NewsLetter />
        <Footer />
      </div>
    );
  }
}
export default Media;



// WEBPACK FOOTER //
// ./src/pages/media.js